module.exports = __webpack_public_path__ + "static/media/my-confirm-list-active.760ae84e.svg";